import './CreatorUpload.css';
import * as encryptUtils from './encryptDecryptUtils';
import * as loggingUtils from './utils/loggingUtils';
import * as mintUtils from './mintUtils';
import HyperaceConnectWalletModal from './HyperaceConnectWalletModal';
import FileUploadImageNouns from './FileUploadImageNouns';
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { createAlchemyWeb3 } from "@alch/alchemy-web3";
import { nounsAuctionHouseContractAddress, mainnetNounsAuctionHouseContractAddress } from "./config";

let web3;
let usedContractAddress;
if(process.env.REACT_APP_IS_MAINNET !== "testnet") {
  web3 = createAlchemyWeb3(process.env.REACT_APP_ETHEREUM_WEBSOCKET_URL);
  usedContractAddress = mainnetNounsAuctionHouseContractAddress;
} else {
  web3 = createAlchemyWeb3(process.env.REACT_APP_GOERLI_WEBSOCKET_URL);
  usedContractAddress = nounsAuctionHouseContractAddress;
}
const nounsAuctionHouseContractJSON = require('./artifacts/contracts/NounsAuctionHouse.sol/NounsAuctionHouse.json');

function NounsUploadForm(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const [publishInit, setPublishInit] = useState(false);
  const [params, setParams] = useState({});
  const [auctionDuration, setAuctionDuration] = useState('');
  const [reservePrice, setReservePrice] = useState('');
  const [files, setFiles] = useState([]);

  async function mintNFT() {
    if(publishInit) {
      return;
    }
    if(
      auctionDuration == null || auctionDuration === '' ||
      params.description == null || params.description === '' ||
      reservePrice == null || reservePrice === '' ||
      params.creatorName == null || params.creatorName === '' ||
      params.name == null || params.name === '' ||
      params.symbol == null || params.symbol === '' ||
      files.length === 0
    ) {
      return;
    }
    setPublishInit(true);
    window.scrollTo(0, document.body.scrollHeight);
    loggingUtils.logEvent(
      props.account != null ? props.account.address : encryptUtils.getWalletUnconnectedUserId(),
      'nouns_upload',
      'nouns_upload_item',
      'info',
      "https://the402.xyz",
      {},
    );
    let paramsCopy = {...params};
    const title = paramsCopy.name;

    paramsCopy["creatorAddress"] = props.account.address;

    // upload images to pinata
    let ppvHashes = [];
    for(let i = 0; i < files.length; i++) {
      let file = files[i];
      let coverPhotoURL = await encryptUtils.writeSingleFilePinata(title, file);
      let paramsCopy2 = {...paramsCopy};
      if(file.type === "image/png" || file.type === "image/jpeg" || file.type === "image/jpeg") {
        paramsCopy2["mediaType"] = 2;
        paramsCopy2["imagePinata"] = coverPhotoURL.replace('gateway.pinata', 'the402.mypinata');
        paramsCopy2["image"] = coverPhotoURL.replace('gateway.pinata', 'the402.mypinata');
      } else if(file.type === "video/mp4" || file.type === "video/quicktime" || file.type === "video/x-quicktime" || file.type === "video/avi") {
        paramsCopy2["mediaType"] = 0;
        paramsCopy2["animation_url"] = coverPhotoURL.replace('gateway.pinata', 'the402.mypinata');
      } else {
        paramsCopy2["mediaType"] = 1;
        paramsCopy2["animation_url"] = coverPhotoURL.replace('gateway.pinata', 'the402.mypinata');
      }
      let ppvHash = await encryptUtils.writeMetadataPinataNouns(paramsCopy2, i);
      ppvHashes.push(ppvHash);
    }

    console.log(ppvHashes);

    let address = await mintUtils.deployNounsTokenContract(
      props.account.address,
      params["name"],
      params["symbol"]
    );
    address = address.toLowerCase();
    let merkleRoot = await mintUtils.uploadNounsInfoToDBAndReturnMerkleRoot(address, ppvHashes);
    console.log(merkleRoot);
    if(merkleRoot == null) {
      return;
    }
    const nounsAuctionHouseContract = new web3.eth.Contract(nounsAuctionHouseContractJSON.abi, usedContractAddress);
    nounsAuctionHouseContract.events.NewNounTokenInitialized().on("data", async function(event) {
      let data = event.returnValues;
      console.log(data);
      console.log(address);
      if(data["nounsTokenContract"].toLowerCase() !== address.toLowerCase()) {
        return;
      }
      let collectionId = parseInt(data["collectionId"]);
      navigate("/auction/" + collectionId + "?autorefresh=true");
    });

    await mintUtils.initializeNounCollection(
      props.account.address,
      address,
      reservePrice,
      auctionDuration,
      props.account.address,
      ppvHashes.length,
      merkleRoot
    );
  }

  function setSymbol(symbol) {
    let paramsCopy = {...params};
    paramsCopy["symbol"] = symbol;
    setParams(paramsCopy);
  }

  function setCreatorName(creatorName) {
    let paramsCopy = {...params};
    paramsCopy["creatorName"] = creatorName;
    setParams(paramsCopy);
  }

  function setTitle(title) {
    let paramsCopy = {...params};
    paramsCopy["name"] = title;
    setParams(paramsCopy);
  }

  function setDescription(description) {
    let paramsCopy = {...params};
    paramsCopy["description"] = description;
    setParams(paramsCopy);
  }

  async function updateReservePrice(price) {
    let paramsCopy = {...params};
    paramsCopy["reservePrice"] = price;
    setParams(paramsCopy);
    setReservePrice(price);
  }

  async function updateAuctionDuration(auctionDuration) {
    let paramsCopy = {...params};
    paramsCopy["auctionDuration"] = auctionDuration;
    setParams(paramsCopy);
    setAuctionDuration(auctionDuration);
  }

  function checkStringWithDecimal(str) {
    return !str.includes("-") && !isNaN(str) && parseFloat(str) >= 0;
  }

  function checkStringIsPositiveInt(str) {
    return !isNaN(str) && (str.match(/^[0-9]+$/) != null) && parseInt(str) > 0;
  }

  function handleSymbolChange(event) {
    setSymbol(event.target.value);
  }

  function handleCreatorNameChange(event) {
    setCreatorName(event.target.value);
  }

  function handleTitleChange(event) {
    setTitle(event.target.value);
  }

  function handleDescriptionChange(event) {
    setDescription(event.target.value);
  }

  function handleAuctionDurationChange(event) {
    if(checkStringIsPositiveInt(event.target.value) || event.target.value === "") {
      updateAuctionDuration(event.target.value);
    } else {
      updateAuctionDuration('');
    }
  }

  function handleReservePriceChange(event) {
    if(checkStringWithDecimal(event.target.value) || event.target.value === "") {
      updateReservePrice(event.target.value);
    } else {
      updateReservePrice('');
    }
  }

  return (
    <div className="w-80 sm:w-128">
      {
        props.account != null
          ?
        <div className = "max-w-lg mx-auto pt-24">
          <div className="justify-center flex flex-col">
            <div className="text-4xl font-bold dark:text-white mt-2">
              Upload
            </div>
            <div className="mt-2">
              <FileUploadImageNouns setMedia={setFiles} />
            </div>
            <div className="text-xl font-semibold text-gray-500 dark:text-zinc-500 mt-2">
              Creator name
            </div>
            <input
              type="text"
              className="dark:bg-zinc-800 text-medium p-2 placeholder-gray-500 dark:text-white w-full font-semibold h-14 bg-gray-200 rounded-lg"
              value={params.creatorName}
              onChange={handleCreatorNameChange}
            />
            <div className="text-xl font-semibold text-gray-500 dark:text-zinc-500 mt-2">
              Collection name
            </div>
            <input
              type="text"
              className="dark:bg-zinc-800 text-medium p-2 placeholder-gray-500 dark:text-white w-full font-semibold h-14 bg-gray-200 rounded-lg"
              value={params.name}
              onChange={handleTitleChange}
            />
            <div className="text-xl font-semibold text-gray-500 dark:text-zinc-500 mt-2">
              Collection symbol
            </div>
            <input
              type="text"
              className="dark:bg-zinc-800 text-medium p-2 placeholder-gray-500 dark:text-white w-full font-semibold h-14 bg-gray-200 rounded-lg"
              value={params.symbol}
              onChange={handleSymbolChange}
            />
            <div className="text-xl font-semibold text-gray-500 dark:text-zinc-500 mt-2">
              Collection description
            </div>
            <textarea
              className="text-medium font-semibold h-48 placeholder-gray-500 w-full p-4 mt-2 rounded-lg flex justify-center items-center dark:text-white bg-gray-200 dark:bg-zinc-800"
              value={params.description}
              onChange={handleDescriptionChange}
            />
            <div className="text-xl font-semibold text-gray-500 dark:text-zinc-500 mt-2">
              Reserve price
            </div>
            <input
              type="number"
              min="0"
              className="dark:bg-zinc-800 p-2 placeholder-gray-500 dark:text-white w-full text-medium font-semibold h-14 bg-gray-200 rounded-lg"
              value={reservePrice}
              onChange={handleReservePriceChange}
            />
            <span class="validity"></span>
            <div className="text-xl font-semibold text-gray-500 dark:text-white dark:text-zinc-500 mt-2">
              Auction duration (seconds)
            </div>
            <input
              type="number"
              min="1"
              className="dark:bg-zinc-800 p-2 placeholder-gray-500 dark:text-white w-full text-medium font-semibold h-14 bg-gray-200 rounded-lg"
              value={auctionDuration}
              onChange={handleAuctionDurationChange}
            />
            <span class="validity"></span>
          </div>
          <div className="h-40">
            {
              publishInit
                ?
              <div className="mx-auto text-center justify-center items-center">
                <div className="mx-auto mt-8 bg-black dark:bg-white h-16 w-64 font-semibold justify-center items-center rounded-lg flex font-medium text-white dark:text-black cursor-pointer" onClick={mintNFT}>
                  <svg role="status" class="w-5 h-5 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                  </svg>
                  Please Wait
                </div>
                <div className="mt-2 text-black dark:text-white">
                  You will have to sign 2 transactions
                </div>
                <div className="mt-2 text-black dark:text-white">
                  The first transaction may take a long time to show up if you are uploading many files. Please do not refresh!
                </div>
              </div>
                :
              <div
                className="mt-8 cursor-pointer elative hover:-translate-y-1 hover:scale-105 duration-500 w-full h-14 flex justify-center items-center text-lsm:text-xl font-bold bg-blue-600 rounded-lg text-white"
                onClick={mintNFT}
              >
                Confirm and upload
              </div>
            }
          </div>
        </div>
          :
        <div className="w-full">
          <HyperaceConnectWalletModal/>
        </div>
      }
    </div>
  );
}

export default NounsUploadForm;
